import { render } from "./PipManagement.vue?vue&type=template&id=2f8aeb09&scoped=true"
import script from "./PipManagement.vue?vue&type=script&lang=js"
export * from "./PipManagement.vue?vue&type=script&lang=js"

import "./PipManagement.vue?vue&type=style&index=0&id=2f8aeb09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8aeb09"]])

export default __exports__